import React from 'react';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { Edit } from '../../constructor/work/Edit';
import { SupportProsType } from '../../constructor/types';

export const SelectSupportType = () => {
  const [typeSupport, setTypeSupport] = React.useState<keyof SupportProsType>(() => {
    return Edit.selectModificationSupport;
  });
  const handleChangeTypeSupport = (event: React.ChangeEvent<HTMLInputElement>) => {
    const mode = event.target.value as keyof SupportProsType;
    Edit.selectModificationSupport = mode;
    setTypeSupport(mode);
  };
  return (
    <FormControl fullWidth margin="normal" disabled={!!Edit?.supportsGroup}>
      <FormLabel
        sx={{
          color: '#ffffff',
          '&.Mui-disabled': {
            color: '#6e6e6e',
          },
        }}
      >
        Типы опор
      </FormLabel>
      <RadioGroup value={typeSupport} onChange={handleChangeTypeSupport}>
        <FormControlLabel
          sx={{ color: '#ffffff' }}
          value="basicStandard"
          control={
            <Radio
              sx={{
                '&.Mui-disabled': {
                  color: '#6e6e6e',
                },
              }}
            />
          }
          label="Basic Standard"
        />
        <FormControlLabel
          sx={{ color: '#ffffff' }}
          value="basicProfessional"
          control={
            <Radio
              sx={{
                '&.Mui-disabled': {
                  color: '#6e6e6e',
                },
              }}
            />
          }
          label="Basic Professional"
        />
      </RadioGroup>
    </FormControl>
  );
};
